import { z } from "zod";

const supportedTimeZones = new Set(
  typeof Intl.supportedValuesOf === "function" ? Intl.supportedValuesOf("timeZone") : [],
);

export function isSupportedTimeZone(value: string): boolean {
  if (value === "UTC") return true;
  if (supportedTimeZones.size > 0) return supportedTimeZones.has(value);
  try {
    return (
      new Intl.DateTimeFormat("en-US", { timeZone: value }).resolvedOptions().timeZone === value
    );
  } catch {
    return false;
  }
}

export const timeZoneSchema = z
  .string()
  .trim()
  .min(1, "Choose a timezone.")
  .max(100, "Choose a valid timezone.")
  .refine(isSupportedTimeZone, "Choose a current IANA timezone.");

export const updateTimeZoneInputSchema = z.object({
  timeZone: timeZoneSchema,
});

export const displayNameSchema = z
  .string()
  .trim()
  .min(1, "Choose the name you want MemoKite to use.")
  .max(80, "Keep your name to 80 characters or fewer.");

export const updateDisplayNameInputSchema = z.object({
  displayName: displayNameSchema,
});

export const settingsResponseSchema = z.object({
  displayName: displayNameSchema,
  email: z.string().email(),
  timeZone: timeZoneSchema.nullable(),
  effectiveTimeZone: timeZoneSchema,
  timeZoneStatus: z.enum(["saved", "missing", "invalid"]),
  hasPassword: z.boolean(),
});

export type UpdateDisplayNameInput = z.infer<typeof updateDisplayNameInputSchema>;
export type UpdateTimeZoneInput = z.infer<typeof updateTimeZoneInputSchema>;
export type SettingsResponse = z.infer<typeof settingsResponseSchema>;
